<template>
  <div id="contact-form">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="20"
        label="Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="Email"
        required
      ></v-text-field>
      <v-text-field
        v-model="telephone"
        :rules="telephoneRules"
        :counter="12"
        label="Telephone"
        required
      ></v-text-field>
      <v-text-field
        v-model="address"
        :rules="addressRules"
        :counter="50"
        label="Address"
        required
      ></v-text-field>
      <v-text-field
        v-model="project"
        :rules="projectRules"
        :counter="20"
        label="Project Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="pricerange"
        :rules="pricerangeRules"
        :counter="8"
        label="Price Range"
        data-vv-name="pricerange"
      ></v-text-field>
      <v-text-field
        v-model="comments"
        label="Comments"
        textarea
      ></v-text-field>
    </v-form>
    <div class="g-recaptcha" id="g-recaptcha" :data-sitekey="sitekey"></div>
    <v-btn :disabled="!valid" @click="submit" color="primary">Submit</v-btn>
    <v-btn @click="clear" dark>Clear</v-btn>
  </div>
</template>

<script>
import Api from '@/api'

export default {
  name: 'contact-form',
  data () {
    return {
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      telephone: '',
      telephoneRules: [
        v => !!v || 'Telephone is required',
        v => /[+0-9]+$/.test(v) || 'Telephone must be valid',
        v => (v && v.length <= 12) || 'Telephone must be less than 12 characters'
      ],
      address: '',
      addressRules: [
        v => !!v || 'Address is required',
        v => (v && v.length <= 50) || 'Address must be less than 50 characters'
      ],
      project: '',
      projectRules: [
        v => !!v || 'Project name is required',
        v => (v && v.length <= 20) || 'Project name must be less than 20 characters'
      ],
      pricerange: '',
      pricerangeRules: [
        v => !!v || 'Price range is required',
        v => /[0-9]+$/.test(v) || 'Price range must be valid',
        v => (v && v.length <= 8) || 'Price range name must be less than 8 characters'
      ],
      comments: '',
      sitekey: '6Lc68m0UAAAAAEG9SN8Q305csTmbBQhTF1MKckZz',
      gRecaptchaToken: ''
    }
  },
  mounted () {
    this.initRecaptcha()
  },
  methods: {
    initRecaptcha () {
      var self = this
      setTimeout(() => {
        if (window.grecaptcha === undefined) {
          self.initRecaptcha()
        } else {
          window.grecaptcha.render('g-recaptcha', {
            sitekey: self.sitekey,
            badge: 'inline',
            callback: self.getToken
          })
        }
      }, 100)
    },
    getToken (token) {
      this.gRecaptchaToken = token
    },
    submit () {
      if (this.$refs.form.validate()) {
        const path = '/contact'
        const data = {
          name: this.name,
          email: this.email,
          address: this.address,
          telephone: this.telephone,
          project: this.project,
          pricerange: this.pricerange,
          comments: this.comments,
          recaptcha_token: this.gRecaptchaToken
        }
        Api.post(path, data)
        .then(response => {
          if (response.data.success) {
            let that = this
            that.clear()
            that.$swal('Contact Details Submitted Succefully!!')
            window.grecaptcha.reset()
          } else {
            // this.$swal('Error Submitting Contact Details!!')
            // window.grecaptcha.reset()
            this.$swal(response.data.message)
          }
        })
        this.$swal('Contact Submission in Progress!!')
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ContactForm.vue